import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import AppLoader from "components/shared/appLoader/AppLoader";
import { useRefreshToken } from "@/hooks/use-refresh-token";
import { hasActiveSession, hasPending2fa } from "@/utils/auth-session";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const accessToken = useSelector((state) => state.auth.accessToken);

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    // SECURITY: never silently refresh while a 2FA challenge is unresolved.
    // The server plants a refresh cookie on the pre-OTP login, so refreshing
    // here would mint a usable access token and let the user reach protected
    // pages without ever completing the OTP step. The lock is held until the
    // OTP is verified (or the attempt is abandoned). See utils/auth-session.
    //
    // FALLBACK (remove the `&& hasActiveSession()` guard once the Express proxy
    // drops Max-Age on the refreshToken cookie, making it a session cookie):
    // only attempt a silent refresh if this browser session is still active.
    // sessionStorage is cleared when the browser is closed, so a reopened
    // browser has no marker -> no silent refresh -> user must log in again.
    if (!hasPending2fa() && !accessToken && hasActiveSession()) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, []); 

  if (isLoading) return <AppLoader />;
  return <Outlet />;
};

export default PersistLogin;
